// @tennis-matches/services/tournament — Startdatum/-zeit für Turnier-Setup

function __pad2(n) {
  return String(n).padStart(2, "0");
}

/** Lokales Kalenderdatum YYYY-MM-DD. */
export function localYmd(d = new Date()) {
  return `${d.getFullYear()}-${__pad2(d.getMonth() + 1)}-${__pad2(d.getDate())}`;
}

/** HH:MM aus lokalem Date. */
export function formatHhmmFromDate(d) {
  return `${__pad2(d.getHours())}:${__pad2(d.getMinutes())}`;
}

/**
 * @param {string} startDate YYYY-MM-DD
 * @param {string} startTime HH:MM
 * @returns {Date|null}
 */
export function parseTournamentStartLocal(startDate, startTime) {
  const sd = String(startDate || "").trim();
  const st = String(startTime || "").trim();
  const m = st.match(/^(\d{1,2}):(\d{2})$/);
  if (!sd || !m) return null;
  const d = new Date(`${sd}T${__pad2(Number(m[1]))}:${m[2]}:00`);
  if (Number.isNaN(d.getTime())) return null;
  return d;
}

/**
 * Vorschlag für neues Setup: heute zur defaultClock, sonst morgen zur defaultClock.
 * @param {{ now?: Date, defaultClock?: string }} [options]
 */
export function suggestDefaultStartDateTime({ now = new Date(), defaultClock = "18:00" } = {}) {
  const clockMatch = String(defaultClock).trim().match(/^(\d{1,2}):(\d{2})$/);
  const defaultHour = clockMatch ? Number(clockMatch[1]) : 18;
  const defaultMinute = clockMatch ? Number(clockMatch[2]) : 0;

  const todayYmd = localYmd(now);
  const candidate = new Date(now);
  candidate.setHours(defaultHour, defaultMinute, 0, 0);

  if (candidate.getTime() > now.getTime()) {
    return { startDate: todayYmd, startTime: formatHhmmFromDate(candidate) };
  }

  const tomorrow = new Date(now);
  tomorrow.setDate(tomorrow.getDate() + 1);
  tomorrow.setHours(defaultHour, defaultMinute, 0, 0);
  return { startDate: localYmd(tomorrow), startTime: formatHhmmFromDate(tomorrow) };
}

export function isTournamentStartInPast(startDate, startTime, now = new Date()) {
  const start = parseTournamentStartLocal(startDate, startTime);
  if (!start) return false;
  return start.getTime() <= now.getTime();
}

export function millisecondsUntilTournamentStart(startDate, startTime, now = new Date()) {
  const start = parseTournamentStartLocal(startDate, startTime);
  if (!start) return null;
  return start.getTime() - now.getTime();
}

export function isTournamentStartWithinHours(startDate, startTime, hours = 24, now = new Date()) {
  const ms = millisecondsUntilTournamentStart(startDate, startTime, now);
  if (ms == null || ms <= 0) return false;
  return ms < hours * 60 * 60 * 1000;
}

/**
 * @param {string} startDate
 * @param {string} startTime
 * @param {{ now?: Date, defaultClock?: string }} [options]
 */
export function normalizeTournamentStartIfPast(startDate, startTime, options = {}) {
  if (!isTournamentStartInPast(startDate, startTime, options.now)) {
    return {
      startDate: String(startDate || "").trim(),
      startTime: String(startTime || "").trim(),
      changed: false,
    };
  }
  const suggested = suggestDefaultStartDateTime(options);
  return { ...suggested, changed: true };
}

/** min-Attribut für type=time, wenn startDate heute ist. */
export function minTimeForDateInput(startDate, now = new Date()) {
  const sd = String(startDate || "").trim();
  if (!sd || sd !== localYmd(now)) return "";
  const d = new Date(now);
  d.setSeconds(0, 0);
  if (d.getTime() <= now.getTime()) d.setMinutes(d.getMinutes() + 1);
  return formatHhmmFromDate(d);
}
